<script lang="ts" setup>
definePageMeta({
    layout: "main",
});
const { width } = useWindowSize();


const [{ data: notices }, { data: events }] = await Promise.all([useBaseFetch("notice"), useBaseFetch("notice/event")]);

const handleRoute = (key: number) => {
    if (key == 0) {
        window.open("https://open.kakao.com/o/skOksPog", "_blank", "noreferrer");
    } else if (key == 1) {
        window.open("https://t.me/ARTE_CS", "_blank", "noreferrer");
    } else if (key == 2) {
        window.open("https://아르떼.com", "_blank", "noreferrer");
    } else if (key == 3) {
        window.open("https://t.me/ARTE_INFORM", "_blank", "noreferrer");
    }
};

</script>
<template>
    <main class="landing flex flex-col px-2 pt-2 gap-1 md:gap-4">
        <CarouselMain />

        <template v-if="width >= 950">

            <div class="relativeFlexColStretchBoth gap-4">
                <div class="relativeFlexRowStretchBoth flex-auto gap-4">
                    <NuxtLink to="/esports/prematch"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc(25%-(1rem/4)*3)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/e-sports.png" alt="ESports" class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/mgame"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc(25%-(1rem/4)*3)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/minigame.png" alt="Minigame" class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/casino/slot"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc(25%-(1rem/4)*3)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/slotgame.png" alt="Slot" class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/mypage/event"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc(25%-(1rem/4)*3)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/event.png" alt="Event" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth flex-auto gap-4">
                    <NuxtLink to="/sports/prematch"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc((100%/3)-(1rem/3)*2)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/pre-match-sports.png" alt="Sports - Prematch"
                            class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/sports/inplay"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc((100%/3)-(1rem/3)*2)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/inplay.png" alt="Sports - Inplay"
                            class="w-full h-auto object-cover" />

                    </NuxtLink>
                    <NuxtLink to="/casino/main"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc((100%/3)-(1rem/3)*2)] max-w-full overflow-hidden">
                        <img src="/images/banner/main/casino.png" alt="Casino" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
            </div>
            <div class="relativeFlexColStretchBoth">
                <img src="/images/banner/main/partner.png" alt="Partner" class="w-full h-auto object-cover" />
            </div>
        </template>

        <template v-if="width < 950">
            <div class="relativeFlexColStretchBoth gap-4">
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/esports/prematch"
                        class="relativeFlexRowStretchBoth flex-[0_0_calc(50%-(1.25rem/2))]">
                        <img src="/images/banner/main/e-sports.png" alt="ESports" class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/mgame" class="relativeFlexRowStretchBoth flex-[0_0_calc(50%-(1.25rem/2))]">
                        <img src="/images/banner/main/minigame.png" alt="Minigame" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/casino/slot" class="relativeFlexRowStretchBoth flex-[0_0_calc(50%-(1.25rem/2))]">
                        <img src="/images/banner/main/slotgame.png" alt="Slot" class="w-full h-auto object-cover" />
                    </NuxtLink>
                    <NuxtLink to="/mypage/event" class="relativeFlexRowStretchBoth flex-[0_0_calc(50%-(1.25rem/2))]">
                        <img src="/images/banner/main/event.png" alt="Event" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/sports/prematch" class="relativeFlexRowStretchBoth flex-1">
                        <img src="/images/banner/main/pre-match-sports.png" alt="Sports - Prematch"
                            class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/sports/inplay" class="relativeFlexRowStretchBoth flex-1">
                        <img src="/images/banner/main/inplay.png" alt="Sports - Inplay"
                            class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/casino/main" class="relativeFlexRowStretchBoth flex-1">
                        <img src="/images/banner/main/casino.png" alt="Casino" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
                <div class="relativeFlexRowStretchBoth gap-5 flex-auto">
                    <NuxtLink to="/mypage/notice" class="relativeFlexRowStretchBoth flex-1">
                        <img src="/images/banner/main/partner.png" alt="Partner" class="w-full h-auto object-cover" />
                    </NuxtLink>
                </div>
            </div>

        </template>
    </main>
</template>
